export default "__VITE_ASSET__B0Y3UeZK__"